import { render, staticRenderFns } from "./DualInputList.vue?vue&type=template&id=996ad754"
import script from "./DualInputList.vue?vue&type=script&lang=js"
export * from "./DualInputList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports